import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
  };

  // Use logo-small.svg for small size, builderbel-logo.svg for larger sizes
  const logoSrc = size === 'sm' ? '/logo-small.svg' : '/builderbel-logo.svg';

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoSrc}
        alt="BuilderBel Logo"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
